import { render, staticRenderFns } from "./ViewInputItemComponent.vue?vue&type=template&id=2eb48dd7&scoped=true&"
import script from "./ViewInputItemComponent.vue?vue&type=script&lang=js&"
export * from "./ViewInputItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewInputItemComponent.vue?vue&type=style&index=0&id=2eb48dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb48dd7",
  null
  
)

export default component.exports